import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
// Dashboard is the landing route — needed on virtually every cold entry, so it
// ships in the main bundle (NOT lazy) and renders directly with the shell.
// It's local-first (SQLite reads resolve in ~50ms) and hydrates synchronously
// from the TanStack cache, so a skeleton would only flash + cause a remount.
import { Dashboard } from "@/features/dashboard/components/dashboard";

export const indexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/",
  component: Dashboard,
});
